/* Starlog scroll reveals.
 * Adds .is-revealed to any [data-reveal] element when it enters the viewport.
 * Honors prefers-reduced-motion (CSS handles the no-op there).
 */
(function () {
  if (typeof window === "undefined") return;

  var reveal = function () {
    var nodes = document.querySelectorAll("[data-reveal]:not(.is-revealed)");
    if (!nodes.length) return;

    if (!("IntersectionObserver" in window)) {
      nodes.forEach(function (n) { n.classList.add("is-revealed"); });
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-revealed");
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });

    nodes.forEach(function (n) { obs.observe(n); });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", reveal);
  } else {
    reveal();
  }

  // Re-scan after Shopify section reloads (theme editor + soft updates).
  document.addEventListener("shopify:section:load", reveal);
})();
